// extracted by css-extract-rspack-plugin
export default {"callDuration":"callDuration-XCQ2QB","input":"input-mBABmz"};